export class Member {
    name:string
    lastName:string
    countryCode: string
    city: string
    sex: string
    age: number
    email: string
    hasJumpedBefore: boolean
    sourceId: string
    signatureData: string;
    agreedOnTerms: boolean;
    agreedOnGDPR: boolean;
}

export class MemberList extends Member {
    memberId: number;
    isMvpPlayer: boolean;
    sourceDescription:string
    dateTimeEntered: Date
    memberProducts: MemberProduct[]
    memberLinks: MemberLink[]
    memberPaymentMethods : MemberPaymentMethod[]
}

export interface MemberPct {
    description: string;
    pct: number;
    qty: number;
    total: number;
}

export interface MemberStats {
    memberAgeGroups: MemberPct[];
    memberCountries: MemberPct[];
    memberMarketingChannels: MemberPct[];
    memberPaymentMethods: MemberPaymentMethod[];
    memberProducts: MemberProduct[];
}


export class MemberProduct {
    memberId: number;
    productId:number;
    description: string;
    startingPrice: number;
    finalPrice: number;
    qty: number;
}

export class MemberLink {
    memberId: number;
    linkUrl: string;
}


export class MemberPaymentMethod {
    memberId: number;
    paymentMethodId:number;
    description: string;
    amount: number;
    qty: number;
}